module.exports = __webpack_public_path__ + "static/media/New-Ideas.efdcf333.png";